/* pd-cart-nudge — "you are 140 kr from free shipping, one of these would do it".
 * Plan: CART_NUDGE.md. Markup: snippets/pd-cart-nudge.liquid.
 *
 * Fills a shell the cart already painted. The customer is on their way to
 * paying, so nothing here may delay the page: the row appears when the answer
 * arrives and stays hidden if it never does.
 *
 * The bike comes from the garage the same way the rail reads it — FitmentWidgets
 * first, localStorage as the fallback — so the two never disagree about which
 * motorcycle is selected.
 */
(function () {
  if (window.__pdNudge) return;
  window.__pdNudge = true;

  /* What is in the cart right now, by variant id.
   *
   * Read from /cart.js on every render, never remembered. An in-memory set
   * was the first attempt and it lied: add a product, take it out again, and
   * the button still said "Lagt i kurv" because nothing ever told the set.
   * The cart is the only thing that knows.
   *
   * It is still held in a variable rather than on the button, because
   * publishing cartUpdate makes the theme re-render the whole drawer section
   * — the button is torn out of the document milliseconds later and the row
   * rebuilt from scratch. */
  var inCart = new Set();

  var money = function (n) {
    try { return new Intl.NumberFormat("da-DK", { minimumFractionDigits: 2 }).format(n) + " kr"; }
    catch (e) { return n + " kr"; }
  };

  function activeVehicle() {
    var fw = window.FitmentWidgets;
    if (fw && fw.getActiveVehicle) { try { return fw.getActiveVehicle(); } catch (e) {} }
    try {
      var key = localStorage.getItem("fitment_garage_active") || "";
      var list = JSON.parse(localStorage.getItem("fitment_garage") || "[]");
      for (var i = 0; i < list.length; i++) {
        var v = list[i];
        if (v && v.year + "|" + v.make + "|" + v.model === key) return v;
      }
    } catch (e) {}
    return null;
  }

  function card(p, cta) {
    var isAdded = inCart.has(String(p.variantId));
    var a = document.createElement("div");
    a.className = "pd-nudge__card";
    var img = p.image
      ? '<img class="pd-nudge__img" src="' + p.image + '" alt="" loading="lazy" width="56" height="56">'
      : '<span class="pd-nudge__img pd-nudge__img--none"></span>';
    a.innerHTML =
      img +
      '<div class="pd-nudge__body">' +
      '<a class="pd-nudge__title" href="/products/' + p.handle + '">' + p.title + "</a>" +
      '<span class="pd-nudge__price">' + money(p.price) + "</span>" +
      "</div>" +
      '<button class="pd-nudge__btn' + (isAdded ? " is-added" : "") + '" type="button"' +
      (isAdded ? " disabled" : "") + ' data-variant="' + p.variantId + '">' +
      (isAdded ? "Lagt i kurv" : cta) + "</button>";
    return a;
  }

  function oilCard(d) {
    var a = document.createElement("a");
    a.className = "pd-nudge__card pd-nudge__card--oil";
    a.href = d.oilUrl;
    a.innerHTML =
      '<img class="pd-nudge__img" src="' + d.oilImage + '" alt="" loading="lazy" width="56" height="56">' +
      '<span class="pd-nudge__body"><span class="pd-nudge__title">' + d.oilTitle + "</span>" +
      '<span class="pd-nudge__price">' + d.oilSub + "</span></span>" +
      '<span class="pd-nudge__btn pd-nudge__btn--ghost">' + d.oilCta + " &rarr;</span>";
    return a;
  }

  /* The product flies to the cart icon.
   *
   * Not decoration: the row sits below the line items, and without it the
   * only feedback is a number changing somewhere off-screen in the header.
   * The flight says WHERE the thing went.
   *
   * A clone on position:fixed, never the card's own image — moving the real
   * one would reflow the row mid-animation. Reduced-motion is honoured by
   * skipping straight to the end, and if the cart icon is not on screen (the
   * drawer covers it) there is nothing to fly to, so it does not run.
   */
  function flyToCart(img) {
    if (!img || !img.src) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
    var target = document.querySelector(".cart-icon, .cart-drawer-button");
    if (!target) return;
    var a = img.getBoundingClientRect();
    var b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;

    var ghost = document.createElement("img");
    ghost.src = img.src;
    ghost.className = "pd-nudge__fly";
    ghost.style.left = a.left + "px";
    ghost.style.top = a.top + "px";
    ghost.style.width = a.width + "px";
    ghost.style.height = a.height + "px";
    document.body.appendChild(ghost);

    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    requestAnimationFrame(function () {
      ghost.style.transform = "translate(" + dx + "px," + dy + "px) scale(.25)";
      ghost.style.opacity = "0";
    });
    // transitionend can be missed if the tab is backgrounded mid-flight, so
    // the timer is the one that actually removes it.
    setTimeout(function () { ghost.remove(); }, 750);
  }

  /* Adding must not navigate, and it must leave the cart telling ONE story.
   *
   * The first version posted to /cart/add.js and then published the theme's
   * cartUpdate with `{ source: "pd-nudge" }`. Every subscriber reads
   * `event.cart`, so they all got undefined: the drawer header said "Din vogn
   * 1", the body drew the empty state and the footer said 150 kr to go —
   * three different answers on one screen, and the customer had to reload.
   *
   * This is the theme's own sequence instead. `cart:grouped-sections` is how
   * its components declare which sections they need re-rendered; the add call
   * carries that list, the response carries the fresh HTML, and the payload
   * is the full cart object the subscribers expect.
   */
  function add(variantId, btn) {
    // Belt and braces: the payload should already carry the numeric id, but
    // a GID slipping through once cost a shipped feature that never worked.
    variantId = String(variantId).split("/").pop();
    // Optimistic: the refresh below replaces this with what the cart says.
    inCart.add(String(variantId));
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = "…";
    var card = btn.closest(".pd-nudge__card");
    flyToCart(card && card.querySelector(".pd-nudge__img"));
    // No longer removing the card on sight: the row stays and refreshes, so
    // the tick is worth reading for a moment before the new suggestions
    // arrive underneath it.

    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sections } }),
    );

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }], sections: sections }),
    })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function (added) {
        return fetch("/cart.js", { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            cart.sections = added.sections;
            var ps = window.FoxTheme && window.FoxTheme.pubsub;
            if (ps && ps.publish && ps.PUB_SUB_EVENTS) ps.publish(ps.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
            else { window.location.reload(); return; }

            // Say so on the button. Without this the only sign anything
            // happened is a number changing in a header the customer may not
            // be looking at, so the click reads as broken and they press it
            // again.
            // The button itself may already be gone — the publish above
            // re-rendered the section — so the record is what matters. The
            // class is still set for the case where it survived.
            var host = btn.closest("[data-pd-nudge]") || document;
            btn.classList.remove("is-working");
            btn.classList.add("is-added");
            btn.innerHTML =
              '<span class="pd-nudge__tick" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" ' +
              'stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M4 12.5l5.2 5.2L20 7" /></svg></span><span>' +
              ((host.dataset && host.dataset.done) || "Tilføjet") + "</span>";
            btn.disabled = true;

            // And show them the cart it went into. On the cart page the row
            // is already visible, so only the drawer needs opening.
            var drawer = document.querySelector("cart-drawer");
            if (drawer && typeof drawer.show === "function" && !drawer.open) drawer.show();
          });
      })
      .catch(function () {
        inCart.delete(String(variantId));
        btn.classList.remove("is-working");
        btn.disabled = false;
        btn.textContent = was;
      });
  }

  function run(el) {
    var sub = parseFloat(el.dataset.subtotal || "0");
    if (!(sub > 0)) return;

    var q = new URLSearchParams({ shop: el.dataset.shop, subtotal: String(sub) });
    if (el.dataset.skus) q.set("skus", el.dataset.skus);
    var v = activeVehicle();
    if (v && v.year && v.make && v.model) {
      q.set("year", v.year); q.set("make", v.make); q.set("model", v.model);
    }

    // Both at once: the suggestions, and what the cart actually holds.
    Promise.all([
      fetch(el.dataset.api + "?" + q.toString(), { credentials: "omit" }).then(function (r) { return r.ok ? r.json() : null; }),
      fetch("/cart.js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; }),
    ])
      .then(function (both) {
        var d = both[0];
        var cart = both[1];
        if (cart && cart.items) {
          inCart = new Set(cart.items.map(function (i) { return String(i.variant_id); }));
        }
        if (!d || !d.show || !d.items || !d.items.length) { hide(el); return; }
        el.querySelector("[data-pd-nudge-head]").textContent =
          d.mode === "more"
            ? el.dataset.headingMore || ""
            : (el.dataset.heading || "").replace("{amount}", money(d.gap));
        var row = el.querySelector("[data-pd-nudge-row]");
        row.textContent = "";
        // Three cards on desktop, two on a phone (merchant 2026-09-26). With an oil filter in the cart
        // the LAST one is "Mangler du olie?" — not a product and not priced: which oil suits an engine
        // is the rider's call, so it points at the range. Without an oil filter there is no oil card.
        var slots = window.matchMedia && window.matchMedia("(max-width: 749px)").matches ? 2 : 3;
        var oil = !!d.oilFilter;
        var n = Math.min(d.items.length, oil ? slots - 1 : slots);
        for (var i = 0; i < n; i++) row.appendChild(card(d.items[i], el.dataset.cta));
        if (oil) row.appendChild(oilCard(el.dataset));
        show(el);
      })
      .catch(function () { hide(el); });
  }

  /* Reveal. The element is unhidden at opacity 0 so the browser has a "from"
   * state to transition out of — flipping hidden alone gives it nothing to
   * animate and the row just appears. The double rAF guarantees that state
   * is painted before the class comes off; a single frame is sometimes
   * coalesced with the change and the transition is skipped. */
  function show(el) {
    if (!el.hidden && !el.classList.contains("is-leaving")) return;
    el.classList.remove("is-leaving");
    el.classList.add("is-entering");
    el.hidden = false;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { el.classList.remove("is-entering"); });
    });
  }

  /* Fade, then hide. Hiding on the spot skips the fade entirely; the layout
   * jump when it finally goes is one reflow, which is the trade the site
   * makes everywhere else rather than animating height. */
  function hide(el) {
    if (el.hidden) return;
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.hidden = true;
      return;
    }
    el.classList.add("is-leaving");
    setTimeout(function () {
      if (el.classList.contains("is-leaving")) { el.hidden = true; el.classList.remove("is-leaving"); }
    }, 240);
  }

  function boot() {
    var els = document.querySelectorAll("[data-pd-nudge]");
    for (var i = 0; i < els.length; i++) run(els[i]);
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest(".pd-nudge__btn");
    // The oil card's action carries the same class but is a link, not a
    // button — catching it here swallowed the click and called add() with no
    // variant, so the card did nothing at all.
    if (!btn || !btn.dataset.variant) return;
    e.preventDefault();
    add(btn.dataset.variant, btn);
  });

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* The cart section is replaced wholesale on every quantity change, so the
   * shell that arrives carries a fresh subtotal and this simply runs again on
   * the new element. No observer: two theme freezes have come from
   * MutationObservers writing what they watch. */
  var ps = window.FoxTheme && window.FoxTheme.pubsub;
  if (ps && ps.subscribe && ps.PUB_SUB_EVENTS) {
    ps.subscribe(ps.PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(boot, 120); });
  }
})();
